/* Модуль видеоплеера (Kinescope, VK, Rutube, GetCourse) */
function isDirectVideoUrl(url) {
    if (!url || typeof url !== 'string') return false;
    return /\.(mp4|webm|ogg|mov)(\?.*)?$/i.test(url) || /fileservice\/file\/download\//i.test(url);
  }

  function normalizeVideoEmbedUrl(rawUrl) {
    if (!rawUrl || typeof rawUrl !== 'string') return '';
    let url = rawUrl.trim();
    // Kinescope: if not embed, convert https://kinescope.io/ID -> https://kinescope.io/embed/ID
    if (/kinescope\.io\/([a-zA-Z0-9]+)$/i.test(url)) {
      url = url.replace(/kinescope\.io\/([a-zA-Z0-9]+)$/i, 'https://kinescope.io/embed/$1');
    }
    // YouTube
    if (/youtube\.com\/watch\?v=([a-zA-Z0-9_-]+)/i.test(url)) {
      url = url.replace(/.*youtube\.com\/watch\?v=([a-zA-Z0-9_-]+).*/i, 'https://www.youtube.com/embed/$1');
    } else if (/youtu\.be\/([a-zA-Z0-9_-]+)/i.test(url)) {
      url = url.replace(/.*youtu\.be\/([a-zA-Z0-9_-]+).*/i, 'https://www.youtube.com/embed/$1');
    }
    // Rutube
    if (/rutube\.ru\/video\/([a-zA-Z0-9_-]+)/i.test(url)) {
      url = url.replace(/.*rutube\.ru\/video\/([a-zA-Z0-9_-]+).*/i, 'https://rutube.ru/play/embed/$1');
    }
    // VK Video
    if (/(?:vk\.com\/video|vkvideo\.ru\/video)(-?\d+)_(\d+)/i.test(url)) {
      const match = url.match(/(?:vk\.com\/video|vkvideo\.ru\/video)(-?\d+)_(\d+)/i);
      if (match) {
        url = `https://vk.com/video_ext.php?oid=${match[1]}&id=${match[2]}&hd=2`;
      }
    }
    return url;
  }

  async function syncSettingsWithBackend() {
    try {
      const res = await fetch(`/api/settings?t=${Date.now()}`);
      if (res.ok) {
        const data = await res.json();
        if (data && data.ok && data.settings) {
          localStorage.setItem('meta_marathon_settings', JSON.stringify(data.settings));
          for (let d = 1; d <= 4; d++) {
            const rec = data.settings[`day${d}_record`];
            if (rec) {
              localStorage.setItem(`meta_day_${d}_video_url`, rec);
            }
          }
          if (data.settings.yandex_metrika_id) {
            initYandexMetrika(data.settings.yandex_metrika_id);
          }
          if (data.settings.bot_username) {
            window.META_BOT_USERNAME = data.settings.bot_username;
            localStorage.setItem('meta_bot_username', data.settings.bot_username);
          }
        }
      }
    } catch (e) {
      // offline / cache fallback
    }
  }

  function getVideoUrlForDay(dayNumber) {
    const saved = localStorage.getItem(`meta_day_${dayNumber}_video_url`);
    if (saved) return saved;

    try {
      const raw = localStorage.getItem('meta_marathon_settings');
      if (raw) {
        const s = JSON.parse(raw);
        const dayKey = `day${dayNumber}`;
        if (s[`${dayKey}_record`]) return s[`${dayKey}_record`];
        if (s[`${dayKey}_kinescope`]) return s[`${dayKey}_kinescope`];
        if (s[`${dayKey}_getcourse`]) return s[`${dayKey}_getcourse`];
      }
    } catch (e) {}

    if (Number(dayNumber) === 1) {
      return '/assets/videos/day-1.mp4';
    }
    if (Number(dayNumber) === 2) {
      return 'https://fs.getcourse.ru/fileservice/file/download/a/658858/sc/133/h/22828b26823da8fa5a1c3d730b6a6c61.mp4';
    }
    if (Number(dayNumber) === 3) {
      return 'https://fs.getcourse.ru/fileservice/file/download/a/658858/sc/183/h/6bf94af5937f01df8b92eb9d78984447.mp4';
    }
    if (Number(dayNumber) === 4) {
      return 'https://fs.getcourse.ru/fileservice/file/download/a/658858/sc/201/h/1dfa62c8705add0562b966cc55fd5288.mp4';
    }

    return '';
  }

  function openVideoPlayer(dayNumber = 1, customUrl = '') {
    triggerHaptic('selection');
    const dayInfo = MARATHON_DAYS_INFO[dayNumber] || { title: `День ${dayNumber}: Урок`, date: 'Доступен в личном кабинете' };
    const videoUrl = (customUrl || getVideoUrlForDay(dayNumber) || '').trim();
    const channelUrl = getChannelUrl();

    // Если есть рабочая ссылка на видеозапись — открываем видеоплеер
    if (videoUrl) {
      let modal = document.getElementById('metaVideoModalBackdrop');
      if (!modal) {
        const html = `
          <div class="meta-video-modal-backdrop" id="metaVideoModalBackdrop">
            <div class="meta-video-modal-card" role="dialog" aria-modal="true">
              <button type="button" class="meta-onboard-close" onclick="MetaOnboarding.closeVideoPlayer()" aria-label="Закрыть">✕</button>

              <div class="meta-video-header">
                <div class="meta-video-title" id="metaVideoModalTitle">
                  🎬 День ${dayNumber}
                </div>
              </div>

              <div class="meta-video-player-wrap" id="metaVideoPlayerWrap"></div>

              <div class="meta-video-actions-row">
                <a href="${videoUrl}" target="_blank" class="btn-video-action-mini" id="metaVideoOpenExternalBtn">
                  <span>↗ Открыть отдельно</span>
                </a>
              </div>
            </div>
          </div>
        `;
        document.body.insertAdjacentHTML('beforeend', html);
        modal = document.getElementById('metaVideoModalBackdrop');
        modal.addEventListener('click', (e) => {
          if (e.target === modal) closeVideoPlayer();
        });
      }

      const titleEl = document.getElementById('metaVideoModalTitle');
      if (titleEl) titleEl.textContent = `🎬 ${dayInfo.title}`;

      const extBtn = document.getElementById('metaVideoOpenExternalBtn');
      if (extBtn) extBtn.href = videoUrl;

      const wrapEl = document.getElementById('metaVideoPlayerWrap');
      if (wrapEl) {
        if (isDirectVideoUrl(videoUrl)) {
          wrapEl.innerHTML = `
            <video src="${videoUrl}" controls playsinline autoplay preload="metadata" style="width: 100%; height: 100%; max-height: 70vh; border-radius: 12px; background: #000; outline: none; box-shadow: 0 4px 20px rgba(0,0,0,0.5);"></video>
          `;
        } else {
          const embedUrl = normalizeVideoEmbedUrl(videoUrl);
          wrapEl.innerHTML = `
            <iframe src="${embedUrl}" allow="autoplay; fullscreen; picture-in-picture; encrypted-media" allowfullscreen style="width: 100%; height: 100%; border: none; border-radius: 12px;"></iframe>
          `;
        }
      }

      modal.classList.add('is-open');
      onModalStateChanged();
      return;
    }

    // Иначе открываем стильную заглушку "Запись появится после открытия урока"
    let stubModal = document.getElementById('metaRecordWaitModalBackdrop');
    if (!stubModal) {
      const html = `
        <div class="meta-wait-modal-backdrop" id="metaRecordWaitModalBackdrop">
          <div class="meta-wait-modal-card" role="dialog" aria-modal="true">
            <button type="button" class="meta-onboard-close" onclick="MetaOnboarding.closeRecordWait()" aria-label="Закрыть">✕</button>
            <div id="metaRecordWaitModalContent"></div>
          </div>
        </div>
      `;
      document.body.insertAdjacentHTML('beforeend', html);
      stubModal = document.getElementById('metaRecordWaitModalBackdrop');
      stubModal.addEventListener('click', (e) => {
        if (e.target === stubModal) closeRecordWait();
      });
    }

    const contentEl = document.getElementById('metaRecordWaitModalContent');
    const isAdmin = Boolean(localStorage.getItem('meta_admin_token'));

    contentEl.innerHTML = `
      <div class="meta-wait-icon-circle">
        <span>🎬</span>
      </div>
      <div class="meta-wait-badge">🕒 Видеоматериал готовится</div>
      <h2 class="meta-wait-title">${escapeHTML(dayInfo.title)}</h2>
      <p class="meta-wait-sub">Статус: <strong>${escapeHTML(dayInfo.date)}</strong></p>

      <div class="meta-wait-info-card">
        <div class="meta-wait-info-text">
          📹 <strong>Видеоурок и разборы натальных карт загружаются в ваш личный кабинет по расписанию прохождения интенсива.</strong>
        </div>
        <div class="meta-wait-info-text" style="margin-top: 6px;">
          Материалы доступны для просмотра онлайн прямо в вашем приложении.
        </div>
      </div>

      <div class="meta-wait-tip">
        <span>💡</span>
        <span>Рекомендуем следить за уведомлениями в боте и канале - мы сообщим, как только новый урок будет готов к просмотру!</span>
      </div>

      <div class="meta-wait-actions">
        <a href="${channelUrl}" target="_blank" class="btn-emerald" style="height: 44px; font-size: 13px; text-decoration: none;">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m22 2-7 20-4-9-9-4Z"/><path d="M22 2 11 13"/></svg>
          <span>📢 Напоминания в Telegram-канале</span>
        </a>
        <button type="button" class="meta-btn-secondary" onclick="MetaOnboarding.closeRecordWait()">
          <span>Понятно, жду открытия</span>
        </button>
      </div>
    `;

    stubModal.classList.add('is-open');
    onModalStateChanged();
  }

  function closeRecordWait() {
    triggerHaptic('light');
    const modal = document.getElementById('metaRecordWaitModalBackdrop');
    if (modal) {
      modal.classList.remove('is-open');
    }
    onModalStateChanged();
  }

  function closeVideoPlayer() {
    triggerHaptic('light');
    const modal = document.getElementById('metaVideoModalBackdrop');
    if (modal) {
      modal.classList.remove('is-open');
      const wrapEl = document.getElementById('metaVideoPlayerWrap');
      if (wrapEl) {
        wrapEl.innerHTML = '';
      }
    }
    onModalStateChanged();
  }

  function toggleInlineVideoFullscreen(wrapperId = 'day1VideoWrapper', videoId = 'day1InlineVideo') {
    const wrapper = document.getElementById(wrapperId);
    const video = document.getElementById(videoId);
    if (!wrapper) return;

    if (wrapper.classList.contains('video-pseudo-fullscreen')) {
      wrapper.classList.remove('video-pseudo-fullscreen');
      const closeBtn = document.getElementById('pseudoFsCloseBtn');
      if (closeBtn) closeBtn.remove();
      document.body.style.overflow = '';
    } else {
      let handled = false;
      if (video && typeof video.webkitEnterFullscreen === 'function') {
        try {
          video.webkitEnterFullscreen();
          handled = true;
        } catch (e) {}
      }
      if (!handled && wrapper.requestFullscreen) {
        wrapper.requestFullscreen().then(() => { handled = true; }).catch(() => {});
      }
      if (!handled) {
        wrapper.classList.add('video-pseudo-fullscreen');
        document.body.style.overflow = 'hidden';
        if (!document.getElementById('pseudoFsCloseBtn')) {
          const btn = document.createElement('button');
          btn.id = 'pseudoFsCloseBtn';
          btn.type = 'button';
          btn.className = 'video-pseudo-fullscreen-close';
          btn.innerHTML = '✕ Свернуть';
          btn.onclick = () => toggleInlineVideoFullscreen(wrapperId, videoId);
          wrapper.appendChild(btn);
        }
      }
    }
  }
  window.toggleInlineVideoFullscreen = toggleInlineVideoFullscreen;

  // Праздничное всплывающее окно при разблокировке дня
  const STORAGE_CELEBRATED = 'meta_celebrated_days';

  function checkCelebration() {
    // В вечнозеленой воронке доступ дается сразу ко всем урокам после подписки на канал.
    // Автоматический модальный попап отключен, чтобы не блокировать экран и не раздражать пользователя.
    return;
  }

  function showCelebrationModal(dayNum, isBonus = false) {
    const info = MARATHON_DAYS_INFO[dayNum] || { title: `День ${dayNum}`, date: 'Урок доступен' };
    let modal = document.getElementById('metaCelebrateBackdrop');
    if (modal) modal.remove();

    const subtitleText = `Урок доступен для просмотра. Видеоурок и обучающие материалы открыты в вашем личном кабинете.`;

    const html = `
      <div class="meta-celebrate-backdrop is-open" id="metaCelebrateBackdrop">
        <div class="meta-celebrate-card" role="dialog" aria-modal="true">
          <div style="font-size: 42px; margin-bottom: 6px;">🎉</div>
          <div class="meta-onboard-badge">✨ Доступ разблокирован!</div>
          <h2 style="font-family: 'Cinzel', Georgia, serif; font-size: 19px; font-weight: 800; margin: 8px 0 6px; line-height: 1.3;">
            Вам открыт ${escapeHTML(info.title)}!
          </h2>
          <p style="font-size: 12.5px; color: #5C5857; line-height: 1.5; margin-bottom: 14px;">
            ${subtitleText}
          </p>

          <div style="background: #FAF8F5; border: 1.5px solid rgba(212, 175, 110, 0.35); border-radius: 14px; padding: 12px 14px; text-align: left; margin-bottom: 16px;">
            <div style="font-size: 11px; font-weight: 700; color: #8C6A2E; text-transform: uppercase; margin-bottom: 4px;">
              📅 Доступ:
            </div>
            <div style="font-size: 14px; font-weight: 800; color: #141214;">
              ${escapeHTML(info.date)}
            </div>
            <div style="font-size: 11.5px; color: var(--text-muted); margin-top: 4px; line-height: 1.45;">
              Вы можете посмотреть видеоурок и материалы прямо в приложении в вашем личном кабинете.
            </div>
          </div>

          <button type="button" class="meta-onboard-btn-submit" onclick="MetaOnboarding.closeCelebrateModal(${dayNum})">
            <span>Отлично, перейти к урокам! →</span>
          </button>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML('beforeend', html);
    triggerHaptic('notification');
  }

  function closeCelebrateModal(dayNum) {
    triggerHaptic('light');
    let celebrated = [];
    try {
      celebrated = JSON.parse(localStorage.getItem(STORAGE_CELEBRATED) || '[]');
    } catch (e) {
      celebrated = [];
    }
    if (!celebrated.includes(dayNum)) {
      celebrated.push(dayNum);
      localStorage.setItem(STORAGE_CELEBRATED, JSON.stringify(celebrated));
    }
    const modal = document.getElementById('metaCelebrateBackdrop');
    if (modal) {
      modal.classList.remove('is-open');
      setTimeout(() => modal.remove(), 300);
    }
  }

  // Обновление личного кабинета под имя пользователя